import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import { CaretDownFilled } from "@ant-design/icons";
import { themeColor } from "./navigationConfig";

const { Item } = Menu;

// Renders the Desktop Navigation Items with dropdown icons
export const renderDesktopNavItems = ({
  mainNavStructure,
  location,
  clickedNav,
  hoveredNav,
  handleMenuItemClick,
  handleMenuItemHover,
  setHoveredNav, // Added this parameter
}) => {
  return mainNavStructure.map((nav) => {
    const isActive =
      location.pathname.startsWith(nav.pathPrefix) ||
      location.pathname === nav.path;
    const hasItems = nav.items && nav.items.length > 0;
    const isOpen = clickedNav === nav.key || hoveredNav === nav.key;

    return (
      <Item
        key={nav.key}
        className="no-underline-menu-item"
        onMouseEnter={() => handleMenuItemHover(nav.key, hasItems)}
        onMouseLeave={() => {
          if (!clickedNav) {
            setHoveredNav(null);
          }
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "0 12px",
            cursor: "pointer",
          }}
          onClick={() => handleMenuItemClick(nav.key, hasItems)}
        >
          <Link
            to={hasItems ? "#" : nav.path}
            style={{
              color: isActive ? "#480558" : "#000",
              backgroundColor: isActive ? "#fff" : "transparent",
              borderBottom: isActive ? "2px solid #480558" : "none",
              display: "inline-block",
              textDecoration: "none",
              fontWeight: isOpen ? "600" : "500",
            }}
            onClick={(e) => {
              if (hasItems) {
                e.preventDefault();
              }
            }}
          >
            {nav.label}
          </Link>
          {hasItems && (
            <CaretDownFilled
              style={{
                marginLeft: "4px",
                fontSize: "14px",
                color: themeColor,
                transition: "transform 0.3s",
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              }}
            />
          )}
        </div>
      </Item>
    );
  });
};

// Renders the Animated Overlay Sub Menu
export const renderHoverSubMenu = ({
  mainNavStructure,
  clickedNav,
  hoveredNav,
  location,
  setClickedNav,
  setHoveredNav,
}) => {
  const activeNavKey = clickedNav || hoveredNav;
  if (!activeNavKey) return null;

  const activeNav = mainNavStructure.find((nav) => nav.key === activeNavKey);
  if (!activeNav || !activeNav.items) return null;

  return (
    <div
      className="animated-overlay-menu"
      onMouseEnter={() => {
        if (!clickedNav) {
          setHoveredNav(activeNavKey);
        }
      }}
      onMouseLeave={() => {
        if (!clickedNav) {
          setHoveredNav(null);
        }
      }}
      style={{
        position: "fixed",
        top: "170px", 
        left: 0,
        right: 0,
        background: "rgba(255, 255, 255, 0.98)",
        backdropFilter: "blur(10px)",
        padding: "40px 0",
        zIndex: 999,
        borderTop: "1px solid #f0f0f0",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
        animation: "slideDown 0.3s ease-out",
      }}
    >
      <div
        style={{
          margin: "0 auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "40px",
          }}
        >
          {activeNav.items.map((item) => {
            const isSubItemActive = location.pathname === item.path;
            return (
              <Link
                key={item.key}
                to={item.path}
                style={{
                  color: isSubItemActive ? "#480558" : themeColor,
                  fontWeight: "600",
                  textDecoration: "none",
                  fontSize: "22px",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  display: "block",
                  transition: "all 0.3s ease",
                  borderLeft: isSubItemActive
                    ? "4px solid #480558"
                    : "4px solid transparent",
                  backgroundColor: isSubItemActive
                    ? "rgba(72, 5, 88, 0.05)"
                    : "transparent",
                  textAlign: "center",
                  minWidth: "200px",
                }}
                onClick={() => {
                  setClickedNav(null);
                  setHoveredNav(null);
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "rgba(72, 5, 88, 0.08)";
                  e.target.style.color = "#480558";
                  e.target.style.transform = "translateX(5px)";
                }}
                onMouseLeave={(e) => {
                  if (!isSubItemActive) {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = themeColor;
                    e.target.style.transform = "translateX(0)";
                  }
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};